import {Emitter, EmitterConfig, OldEmitterConfig} from "pixi-particles";

interface IPoints {
    x: number,
    y: number
}

export class TrailUtils {
    public static emitterConfig: EmitterConfig | OldEmitterConfig = {
        autoUpdate: true,
        alpha: {
            start: 0.8,
            end: 0.15
        },
        scale: {
            start: 1,
            end: 0.2,
            minimumScaleMultiplier: 1
        },
        color: {
            start: "#fcff00",
            end: "#fcff00"
        },
        speed: {
            start: 0,
            end: 0,
            minimumSpeedMultiplier: 1
        },
        acceleration: {
            x: 0,
            y: 0
        },
        maxSpeed: 0,
        startRotation: {
            min: 0,
            max: 0
        },
        noRotation: true,
        rotationSpeed: {
            min: 0,
            max: 0
        },
        lifetime: {
            min: 0,
            max: 0.4
        },
        blendMode: "normal",
        frequency: 0.0008,
        emitterLifetime: -1,
        maxParticles: 1000,
        pos: {
            x: 0,
            y: 0
        },
        addAtBack: false,
        spawnType: "point"
    };

    public static getCurvePathsFromTwoPoints(source: PIXI.Point, dest: PIXI.Point, curveRadius: number): IPoints[] {
        const midX: number = source.x + ((dest.x - source.x) / 2),
            midY: number = source.y + ((dest.y - source.y) / 2),
            xDiff: number = midX - source.x,
            yDiff: number = midY - source.y,
            angle: number = (Math.atan2(yDiff, xDiff) * (180 / Math.PI)) - 90,
            angleRadians: number = TrailUtils.getRadians(angle),
            pointX: number = (midX - curveRadius * Math.sin(angleRadians)),
            pointY: number = (midY - curveRadius * Math.cos(angleRadians)),
            pointX1: number = (midX + curveRadius * Math.cos(angleRadians)),
            pointY1: number = (midY + curveRadius * Math.sin(angleRadians));
        return [source, {x: pointX, y: pointY}, {x: pointX1, y: pointY1}, dest];
    }

    public static updateTrail(delta: number, emitterPos: PIXI.Point, emitter: Emitter, pointer: PIXI.Point): void {
        const sharpness: number = 0.1;
        const minDelta: number = 0.05;
        if (!emitterPos.equals(pointer)) {

            const dt: number = 1 - Math.pow(1 - sharpness, delta);
            const dx: number = pointer.x - emitterPos.x;
            const dy: number = pointer.y - emitterPos.y;

            if (Math.abs(dx) > minDelta) {
                emitterPos.x += dx * dt;
            } else {
                emitterPos.x = pointer.x;
            }

            if (Math.abs(dy) > minDelta) {
                emitterPos.y += dy * dt;
            } else {
                emitterPos.y = pointer.y;
            }
            emitter.updateOwnerPos(emitterPos.x, emitterPos.y);
        }
    }

    public static distanceBetweenTwoPoints(source: PIXI.Point, dest: PIXI.Point): number {
        return Math.sqrt(Math.pow((dest.x - source.x), 2) + Math.pow((dest.y - source.y), 2));
    }

    public static getRadians(degree: number): number {
        var pi: number = Math.PI;
        return degree * (pi / 180);
    }
}
